export default {
  /**
   * This will mutate INTERFACE_GET(baseType) into INTERFACE_GET_USER(baseType.subAction)
   **/
  mutate(baseType, subAction) {
    return subAction == null ? baseType : `${subAction}.${subAction}`;
  },
  STATUS_LOADING: 'api.status.loading',
  STATUS_DONE: 'api.status.done',
  STATUS_ERROR: 'api.status.error',
  INTERFACE_STATUS: 'api.interface.status',
  INTERFACE_BULK: 'api.interface.bulk',
  INTERFACE_GET: 'api.interface.get',
  INTERFACE_LIST: 'api.interface.list',
  INTERFACE_CREATE_SET: 'api.interface.createSet',
  INTERFACE_CREATE_ADD: 'api.interface.createAdd',
  INTERFACE_UPDATE: 'api.interface.update',
  INTERFACE_REMOVE: 'api.interface.remove',
  INTERFACE_GET_HISTORY: 'api.interface.get.history',
  INTERFACE_GET_USER: 'api.interface.get.user',
  INTERFACE_LIST_USER: 'api.interface.user.list',
  INTERFACE_CREATE_USER: 'api.interface.user.create',
  INTERFACE_ADD_USER: 'api.interface.user.add',
  INTERFACE_REMOVE_USER: 'api.interface.user.remove',
  INTERFACE_UPDATE_USER: 'api.interface.user.update',
  INTERFACE_SEND_OUTBOUND_DEVICE_MESSAGE: 'api.interface.device.message.send',
  INTERFACE_STATUS_LOADING: 'api.interface.status.loading',
  INTERFACE_STATUS_ERROR: 'api.interface.status.error',
  INTERFACE_STATUS_DONE: 'api.interface.status.done',
  INTERFACE_FILTER: 'api.interface.filter',
  INTERFACE_DEFAULT_QUERY_NAME: 'default',
  USERS_STATUS_ERROR: 'api.status.error',
  GET_USERS_STATUS: 'api.get.users.status',
  GET_USERS: 'api.get.users',
  GET_USER: 'api.get.user',
  ADD_USER: 'api.add.user',
  REMOVE_USER: 'api.remove.user',
  UPDATE_USER: 'api.update.user',
  TWO_FACTOR_GENERATE_CODE: 'api.twoFactor.generateCode',
  TWO_FACTOR_PREACTIVATE_METHOD: 'api.twoFactor.preActivateMethod',
  TWO_FACTOR_ACTIVATE_METHOD: 'api.twoFactor.activateMethod',
  TWO_FACTOR_DEACTIVATE_METHOD: 'api.twoFactor.deactivateMethod',
  TWO_FACTOR_DEACTIVATE: 'api.twoFactor.deactivate',
  TWO_FACTOR_GET_ONE_TIME_LOGIN_CODES: 'api.twoFactor.getOneTimeLoginCodes',
  TWO_FACTOR_REGENERATE_ONE_TIME_LOGIN_CODES: 'api.twoFactor.regenerateOneTimeLoginCodes',
  TWO_FACTOR_ERROR: 'api.twoFactor.error',
  AUTH_VERIFYING: 'api.profile.verifying',
  AUTH_LOGGING_IN: 'api.profile.loggingIn',
  AUTH_LOGGING_IN_WITH_2FA: 'api.profile.loggingInWith2FA',
  AUTH_LOGGED_IN: 'api.profile.loggedIn',
  // User profile already has 2FA activated and must now use it to login
  AUTH_REQUIRES_2FA: 'api.profile.requires2FA',
  // User profile does NOT have 2FA activated and must now enroll
  AUTH_REQUIRES_2FA_ENROLL: 'api.profile.requires2FAEnroll',
  AUTH_TWO_FACTOR_PREACTIVATE_SUCCESS: 'api.twoFactor.preActivateMethodSuccess',
  AUTH_TWO_FACTOR_PREACTIVATE_ERROR: 'api.twoFactor.preActivateMethodError',
  AUTH_TWO_FACTOR_ACTIVATE_SUCCESS: 'api.twoFactor.activateMethodSuccess',
  AUTH_TWO_FACTOR_ACTIVATE_ERROR: 'api.twoFactor.activateMethodError',
  AUTH_RESET_2FA_VERIFY: 'api.profile.reset2FAVerify',
  AUTH_LOGGING_OUT: 'api.profile.loggingOut',
  AUTH_LOGGED_OUT: 'api.profile.loggedOut',
  AUTH_LOG_OUT_FAILED: 'api.profile.logOutFailed',
  AUTH_LOGIN_FAILED: 'api.profile.loginFailed',
  AUTH_LOGIN_WITH_2FA_FAILED: 'api.profile.loginWith2FAFailed',
  AUTH_VERIFY_FAILED: 'api.profile.verifyFailed',
  AUTH_RENEWING: 'api.profile.renewing',
  AUTH_RENEWED: 'api.profile.renewed',
  AUTH_SENDING_FORGOT_PASSWORD: 'api.profile.sendingForgotPassword',
  AUTH_SENT_FORGOT_PASSWORD: 'api.profile.sentForgotPassword',
  AUTH_SEND_FORGOT_PASSWORD_FAILED: 'api.profile.sendForgotPasswordFailed',
  AUTH_CHANGING_PASSWORD: 'api.profile.changingPassword',
  AUTH_CHANGED_PASSWORD: 'api.profile.changedPassword',
  AUTH_CHANGE_PASSWORD_FAILED: 'api.profile.changePasswordfailed',
  AUTH_RESETTING_PASSWORD: 'api.profile.resettingPassword',
  AUTH_RESET_PASSWORD: 'api.profile.resetPassword',
  AUTH_RESET_PASSWORD_FAILED: 'api.profile.resetPasswordFailed',
  AUTH_ACTIVATING_ACCOUNT: 'api.profile.activatingAccount',
  AUTH_ACTIVATED_ACCOUNT: 'api.profile.activatedAccount',
  AUTH_ACTIVATE_ACCOUNT_FAILED: 'api.profile.activateAccountFailed',
  AUTH_REQUESTING_DEVICE_CODE: 'api.profile.requestingDeviceCode',
  AUTH_REQUESTED_DEVICE_CODE: 'api.profile.requestedDeviceCode',
  AUTH_REQUEST_DEVICE_CODE_FAILED: 'api.profile.requestDeviceCodeFailed',
  AUTH_CONFIRMING_DEVICE_CODE: 'api.profile.confirmingDeviceCode',
  AUTH_CONFIRMED_DEVICE_CODE: 'api.profile.confirmedDeviceCode',
  AUTH_CONFIRM_DEVICE_CODE_FAILED: 'api.profile.confirmDeviceCodeFailed',
  AUTH_REQUESTING_DEVICE_ACCESS_TOKEN: 'api.profile.requestingDeviceAccessToken',
  AUTH_REQUEST_DEVICE_ACCESS_TOKEN_FAILED: 'api.profile.requestDeviceAccessTokenFailed',
  AUTH_SET_USER_CODE: 'api.profile.setUserCode',
  AUTH_CLEAR_USER_CODE: 'api.profile.clearUserCode',
  AUTH_DEVICE_CODE_SUCCESS_CODE_TYPE: 'imagine.login.deviceCodeRequestSuccessful',
  AUTH_LOGGING_IN_DEVICE_CODE: 'api.profile.loggingInDeviceCode',
  AUTH_LOGGING_IN_WITH_2FA_DEVICE_CODE: 'api.profile.loggingInWith2FADeviceCode',
  AUTH_LOGGED_IN_DEVICE_CODE: 'api.profile.loggedInDeviceCode',
  AUTH_LOGIN_FAILED_DEVICE_CODE: 'api.profile.loginFailedDeviceCode',
  AUTH_REQUIRES_2FA_DEVICE_CODE: 'api.profile.requires2FADeviceCode',
  AUTH_REQUESTING_LOGIN_CODE: 'api.profile.requestingLoginCode',
  AUTH_REQUESTED_LOGIN_CODE: 'api.profile.requestedLoginCode',
  AUTH_REQUEST_LOGIN_CODE_FAILED: 'api.profile.requestLoginCodeFailed',
  AUTH_SUBMITTING_LOGIN_CODE: 'api.profile.submittingLoginCode',
  AUTH_SUBMIT_LOGIN_CODE_FAILED: 'api.profile.submitLoginCodeFailed',
  AUTH_UPDATE_PROFILE: 'api.profile.updateProfile',
  ADD_QUERY: 'api.query.add',
  REMOVE_QUERY: 'api.query.remove',
  UPDATE_QUERY: 'api.query.update',
  START_QUERY: 'api.query.start',
  QUERY_ERROR: 'api.query.error',
  QUERY_SUCCESS: 'api.query.success',
  QUERY_STATUS_LOADING: 'api.query.status.loading',
  QUERY_STATUS_SUCCESS: 'api.query.status.success',
  QUERY_STATUS_FAILED: 'api.query.status.failed',
  QUERY_CLEAR_RESULTS: 'api.query.clearResults',
  QUERY_OPTIMIZE_DOWNLOAD: 'api.query.optimize.download',
  QUERY_OPTIMIZE_QUERY: 'api.query.optimize.query',
  ENUM_STATUS: 'api.project.enums.status',
  ENUM_LIST: 'api.project.enums.list',
  ENUM_GET: 'api.project.enums.get',
  ENUM_ADD: 'api.project.enums.add',
  ENUM_ADD_VALUE: 'api.project.enums.addValue',
  ENUM_UPDATE_VALUE: 'api.project.enums.updateValue',
  ENUM_REMOVE_VALUE: 'api.project.enums.removeValue',
  ENUM_VALUES: 'api.project.enums.values',
  ENUM_DELETE_ALL: 'api.project.enums.deleteAll',
  ENUM_REMOVE: 'api.project.enums.remove',
  ENUM_UPDATE: 'api.project.enums.update',
  RESOURCE_ENUM_STATUS: 'api.resourceEnum.status',
  RESOURCE_ENUM_LIST: 'api.resourceEnum.list',
  RESOURCE_ENUM_GET: 'api.resourceEnum.get',
  RESOURCE_ENUM_ADD: 'api.resourceEnum.add',
  RESOURCE_ENUM_ADD_VALUE: 'api.resourceEnum.addValue',
  RESOURCE_ENUM_UPDATE_VALUE: 'api.resourceEnum.updateValue',
  RESOURCE_ENUM_REMOVE_VALUE: 'api.resourceEnum.removeValue',
  RESOURCE_ENUM_VALUES: 'api.resourceEnum.values',
  RESOURCE_ENUM_DELETE_ALL: 'api.resourceEnum.deleteAll',
  RESOURCE_ENUM_REMOVE: 'api.resourceEnum.remove',
  RESOURCE_ENUM_UPDATE: 'api.resourceEnum.update',
  RESOURCE_ENUM_RESET_VALUES: 'api.resourceEnum.resetValues',
  API_ACCESS_KEY_STATUS: 'api.apiAccessKey.status',
  API_ACCESS_KEY_LIST: 'api.apiAccessKey.list',
  API_ACCESS_KEY_GET: 'api.apiAccessKey.get',
  API_ACCESS_KEY_ADD: 'api.apiAccessKey.add',
  API_ACCESS_KEY_UPDATE: 'api.apiAccessKey.update',
  API_ACCESS_KEY_REMOVE: 'api.apiAccessKey.remove',
  BLUEPRINT_STATUS: 'api.project.blueprint.status',
  BLUEPRINT_LIST: 'api.project.blueprint.list',
  BLUEPRINT_GET: 'api.project.blueprint.get',
  BLUEPRINT_ADD: 'api.project.blueprint.add',
  BLUEPRINT_REMOVE: 'api.project.blueprint.remove',
  BLUEPRINT_UPDATE: 'api.project.blueprint.update',
  ROLE_STATUS: 'api.project.role.status',
  ROLE_LIST: 'api.project.role.list',
  ROLE_GET: 'api.project.role.get',
  ROLE_ADD: 'api.project.role.add',
  ROLE_REMOVE: 'api.project.role.remove',
  ROLE_UPDATE: 'api.project.role.update',
  MODULE_STATUS: 'api.project.module.status',
  MODULE_LIST: 'api.project.module.list',
  MODULE_GET: 'api.project.module.get',
  MODULE_ADD: 'api.project.module.add',
  MODULE_REMOVE: 'api.project.module.remove',
  MODULE_UPDATE: 'api.project.module.update',
  PERMISSION_STATUS: 'api.project.permission.status',
  PERMISSION_LIST: 'api.project.permission.list',
  PERMISSION_GET: 'api.project.permission.get',
  PERMISSION_ADD: 'api.project.permission.add',
  PERMISSION_REMOVE: 'api.project.permission.remove',
  PERMISSION_UPDATE: 'api.project.permission.update',
  RESOURCE_USER_STATUS: 'api.resourceUser.status',
  RESOURCE_USER_LIST: 'api.resourceUser.list',
  RESOURCE_USER_GET: 'api.resourceUser.get',
  RESOURCE_USER_ADD: 'api.resourceUser.add',
  RESOURCE_USER_REMOVE: 'api.resourceUser.remove',
  RESOURCE_USER_UPDATE: 'api.resourceUser.update',
  RESOURCE_USER_UPDATE_ROLES: 'api.resourceUser.updateRoles',
  RESOURCE_USER_ADD_ROLES: 'api.resourceUser.addRoles',
  RESOURCE_USER_REMOVE_ROLES: 'api.resourceUser.removeRoles',
  RESOURCE_USER_REMOVE_ALL_ROLES: 'api.resourceUser.removeAllRoles',
  ALLOWED_SET: 'api.allowed',
  RSRC_CREATE: 'api.rsrc.create',
  RSRC_GET: 'api.rsrc.get',
  RSRC_UPDATE: 'api.rsrc.update',
  RSRC_DELETE: 'api.rsrc.delete',
  RSRC_LIST: 'api.rsrc.list',
  RSRC_STATUS: 'api.rsrc.status',
  OIDC_CLIENT_STATUS: 'api.project.oidcClient.status',
  OIDC_CLIENT_LIST: 'api.project.oidcClient.list',
  OIDC_CLIENT_GET: 'api.project.oidcClient.get',
  OIDC_CLIENT_ADD: 'api.project.oidcClient.add',
  OIDC_CLIENT_REMOVE: 'api.project.oidcClient.remove',
  OIDC_CLIENT_UPDATE: 'api.project.oidcClient.update',
  OIDC_CLIENT_LOGIN_URL: 'api.project.oidcClient.loginUrl',
  GET_DEVICE_BY_NETWORK_ALIAS: 'api.getDeviceByNetworkAlias',
  AUTH_PROFILE_TYPE_2FA: '2FAVerify',
  AUTH_PROFILE_TYPE_2FA_REQUIRE_ENROLL: '2FARequireEnroll',
  MAINTENANCE_EVENT_LIST: 'api.maintenanceEvent.list',
  MAINTENANCE_EVENT_LIST_ACTIVE: 'api.maintenanceEvent.listActive',
  MAINTENANCE_EVENT_STATUS: 'api.maintenanceEvent.status',
  MAINTENANCE_EVENT_ADD: 'api.maintenanceEvent.create',
  MAINTENANCE_EVENT_REMOVE: 'api.maintenanceEvent.remove',
  MAINTENANCE_EVENT_GET: 'api.maintenanceEvent.get',
  MAINTENANCE_EVENT_UPDATE: 'api.maintenanceEvent.update',
  RULE_STATUS: 'api.rule.status',
  RULE_LIST: 'api.rule.list',
  RULE_GET: 'api.rule.get',
  RULE_ADD: 'api.rule.add',
  RULE_REMOVE: 'api.rule.remove',
  RULE_BULK_REMOVE: 'api.rule.bulkRemove',
  RULE_UPDATE: 'api.rule.update',
  RESOURCE_TEMPORARY_USER_STATUS: 'api.resourceTemporaryUser.status',
  RESOURCE_TEMPORARY_USER_LIST: 'api.resourceTemporaryUser.list',
  RESOURCE_TEMPORARY_USER_ADD: 'api.resourceTemporaryUser.add',
  RESOURCE_TEMPORARY_USER_REMOVE: 'api.resourceTemporaryUser.remove',
  RESOURCE_TEMPORARY_USER_UPDATE: 'api.resourceTemporaryUser.update',
  // CURRENTLY UNUSED
  RESOURCE_TEMPORARY_USER_UPDATE_ROLES: 'api.resourceTemporaryUser.updateRoles',
  RESOURCE_TEMPORARY_USER_ADD_ROLES: 'api.resourceTemporaryUser.addRoles',
  RESOURCE_TEMPORARY_USER_REMOVE_ROLES: 'api.resourceTemporaryUser.removeRoles',
  RESOURCE_TEMPORARY_USER_REMOVE_ALL_ROLES: 'api.resourceTemporaryUser.removeAllRoles',
  CLIENT_ID_STATUS: 'api.clientId.status',
  CLIENT_ID_LIST: 'api.clientId.list',
  CLIENT_ID_GET: 'api.clientId.get',
  CLIENT_ID_ADD: 'api.clientId.add',
  CLIENT_ID_REMOVE: 'api.clientId.remove',
  CLIENT_ID_BULK_REMOVE: 'api.clientId.bulkRemove',
  CLIENT_ID_UPDATE: 'api.clientId.update'
};